// import React from "react";
// import { Input } from "@windmill/react-ui";

// const InputAreaPrice = ({
//   register,
//   defaultValue,
//   required,
//   name,
//   label,
//   type,
//   placeholder,
//   pattern,
//   minLength,
//   maxLength,
//   value,
//   readOnly,
//   onChangeFunction,
//   val,
//   fromCity,
//   toCity,
//   disabled,
// }) => {
//   const handleInput = (e) => {
//     let val = e.target.value;

//     if (val) {
//       // Allow '.' for extra_km only
//       if (name.startsWith("extra_km")) {
//         val = val.replace(/[^0-9.]/g, ""); // Allow numbers and dot
//         val = val.replace(/\.(?=.*\.)/g, ""); // Allow only one dot
//       } else if (name.startsWith("duration")) {
//         val = val.replace(/[^a-zA-Z0-9. ]/g, "");
//       } else {
//         val = val.replace(/[^0-9]/g, ""); // Allow numbers only, no dot
//       }
//     }
//     e.target.value = val;
//     const inputValue = e.target.value;
//     if (inputValue.length > maxLength) {
//       e.target.value = inputValue.slice(0, maxLength);
//       return;
//     }
//   };

//   return (
//     <>
//       <Input
//         {...register(name, {
//           required: value  ? false : `${label} is required!`, // Validation rule
//         })}
//         defaultValue={defaultValue}
//         type={type}
//         placeholder={placeholder}
//         name={name}
//         onInput={handleInput}
//         onChange={(e) => onChangeFunction ? onChangeFunction(e) : null}

//         value={value}
//         disabled={disabled}
//         step="any"
//         readOnly={readOnly}
//         autoComplete="off"
//         className="border h-10 text-sm focus:outline-none block w-full bg-white-100 dark:bg-white border-transparent focus:bg-white"
//       />
//     </>
//   );
// };

// export default InputAreaPrice;




import React from "react";
import { Input } from "@windmill/react-ui";

const InputAreaPrice = ({
  register,
  defaultValue,
  required,
  name,
  label,
  type,
  placeholder,
  pattern,
  minLength,
  maxLength,
  value,
  readOnly,
  onChangeFunction,
  val,
  fromCity,
  toCity,
  disabled,

  // NEW
  isOverrideMargin = false,
}) => {
  const handleInput = (e) => {
    let input = e.target.value;

    if (input) {
      if (name?.startsWith("extra_km")) {
        input = input.replace(/[^0-9.]/g, "");
        input = input.replace(/\.(?=.*\.)/g, "");
      } else if (name?.startsWith("duration")) {
        input = input.replace(/[^a-zA-Z0-9. ]/g, "");
      } else {
        input = input.replace(/[^0-9]/g, "");
      }
    }

    e.target.value = input;

    if (
      maxLength &&
      e.target.value.length > maxLength
    ) {
      e.target.value = e.target.value.slice(
        0,
        maxLength
      );
    }
  };

  return (
    <Input
      {...(
        isOverrideMargin
          ? (name ? register(name) : {})
          : register(name, {
            required: value
              ? false
              : `${label} is required!`,
          })
      )}

      type={type}
      name={name}
      placeholder={placeholder}

      defaultValue={
        isOverrideMargin
          ? undefined
          : defaultValue
      }

      value={
        isOverrideMargin
          ? value ?? ""
          : value
      }

      onInput={handleInput}

      onChange={(e) =>
        onChangeFunction?.(e)
      }

      disabled={disabled}
      readOnly={readOnly}
      step="any"
      autoComplete="off"

      className="border h-10 text-sm focus:outline-none block w-full bg-white dark:bg-white border-transparent focus:bg-white"
    />
  );
};

export default InputAreaPrice;